import React, { FC, useEffect } from 'react';

import { GoalVizEvent } from '~/core/enums';

type Props = {
    pos: string;
    eventId: string | number;
    size: googletag.GeneralSize;
    gameId: number;
    period: number;
    eventType?: GoalVizEvent;
};

const AD_TAG_NETWORK_CODE = window.__AD_SETTINGS__?.adTagNetworkCode;
const PARENT_AD_UNIT = window.__AD_SETTINGS__?.parentAdUnit;
const RINK_AD_UNIT = `/${AD_TAG_NETWORK_CODE}/${PARENT_AD_UNIT}/gamecenter/rink`;

const AdSlot: FC<Props> = ({ pos, eventId, size, gameId, period, eventType }) => {
    const slotId = `ad-rink-${pos}-${eventId}`;
    const adPeriod: string = period > 3 ? 'OT' : period.toString();

    useEffect(() => {
        window.googletag = window.googletag || { cmd: [] };
        let slot: googletag.Slot | null;

        window.googletag.cmd.push(() => {
            slot = window.googletag.defineSlot(RINK_AD_UNIT, size, slotId);

            if (slot) {
                slot.addService(googletag.pubads())
                    .setTargeting('pos', pos)
                    .setTargeting('event', eventType || '')
                    .setTargeting('gameId', gameId.toString())
                    .setTargeting('period', adPeriod);

                googletag.enableServices();
                window.googletag.display(slotId);
                googletag.pubads().refresh([slot]);
            }
        });

        // Clean up the slot when the component is unloaded.
        return () => {
            window.googletag.cmd.push(() => {
                slot && window.googletag.destroySlots([slot]);
            });
        };
    }, [slotId, size, period, pos, eventType, gameId, adPeriod]);

    return <div id={slotId} />;
};

export default AdSlot;
